import { lazy, useMemo } from 'react';
import { BlockWrapper, defineBlock, useEditor, useInspectorControl, smartProps } from '@smartfire/js-block-engine';
import Arrow from './arrow';
import { ReactComponent as PDFIcon } from './assets/pdf-icon.svg';
import clsx from 'clsx';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector'));

export const Button = ({
    text,
    linkType,
    link,
    targetBlank = false,
    type = 'filled',
    shape = 'squared',
    arrow = 'rightArrow',
    color = style.yellow,
    color2 = style.blue,
    align,
    className = null,
    wrapper = false,
    showInspector = true,
    tagName = 'a',
    isSubmit = false,
    postType = null,
    fileId = null,
    postId = 0,
    taxonomy = '',
    termId = 0,
    isLoading = false,
    ...props
}) => {
    const { isEditing } = useEditor();

    useInspectorControl(showInspector ? Inspector : () => '');

    const href = useMemo(() => {
        switch (linkType) {
            case 'email':
                return 'mailto:' + link;

            case 'tel':
                return 'tel:' + link;

            default:
                return link;
        }
    }, [link, linkType]);

    const Tag = tagName;

    const dark = color === style.blue || color === style.blue2 || color === style.black;
    const hoverDark = color2 === style.blue || color2 === style.blue2 || color2 === style.black;

    return (
        <Tag
            className={clsx(
                className,
                style.button,
                style[type],
                style[shape],
                style[arrow],
                style[linkType],
                dark && style.dark,
                hoverDark && style.hoverDark,
                isLoading && style.loading,
            )}
            href={!isEditing && href ? href : undefined}
            target={targetBlank ? '_blank' : undefined}
            download={linkType === 'file'}
            type={isSubmit ? 'submit' : null}
            style={{ '--color': color, '--color2': color2 }}
            {...props}
        >
            {linkType === 'file' && <PDFIcon className={style.pdfIcon} />}
            <div className={style.back}></div>
            {text && <span className={style.text}>{text}</span>}
            {props.children}
            {!isLoading && <Arrow className={style.icon} />}
        </Tag>
    );
};

const ButtonBlock = ({ align, ...props }) => {
    return (
        <BlockWrapper.Div className={clsx(style.wrapper, align && style[align])}>
            <Button {...props} />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: ButtonBlock,
    smartProps: {
        text: smartProps.string.withDefault('Mon Bouton'),
        linkType: smartProps.string.withDefault('other'),
        link: smartProps.string.withDefault(''),
        postType: smartProps.string.withDefault(''),
        fileId: smartProps.number.withDefault(0),
        targetBlank: smartProps.bool.withDefault(false),
        type: smartProps.string.withDefault('filled'),
        shape: smartProps.string.withDefault('squared'),
        arrow: smartProps.string.withDefault('rightArrow'),
        color: smartProps.string.withDefault(style.yellow),
        color2: smartProps.string.withDefault(style.blue),
        align: smartProps.string.withDefault('center'),
        postId: smartProps.number.withDefault(0),
        taxonomy: smartProps.string.withDefault(''),
        termId: smartProps.number.withDefault(0),
    },
    setup: {
        title: 'Bouton',
    },
});
